import { useNavigate, useParams } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

import { Button, Card, PageTitle, PageWrapper, formatId } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { Breadcrumb } from '../breadcrumb';
import { Carrier } from '../edit/carrier';
import { Menu } from '../menu';
import { useCarrierContractSuspenseQuery } from '../queries';
import { BasicInfo } from './basic-info';
import { Configuration } from './configuration';

export function Page() {
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: contract } = useCarrierContractSuspenseQuery({ contract_id: id });
  const navigate = useNavigate();

  return (
    <PageWrapper variant="center">
      <PageTitle.Wrapper>
        <PageTitle.Stack>
          <Breadcrumb currentPage={formatId(contract.contract_id)} />
        </PageTitle.Stack>

        <Button as={RouterLink} to={`../${AppRoute.EDIT}/${contract?.contract_id}`}>
          {t('common.edit')}
        </Button>

        <Menu>
          <Menu.DuplicateItem contractId={contract.contract_id!} />
          <Menu.DeleteItem contractId={contract.contract_id!} onSuccess={() => navigate('..')} />
        </Menu>
      </PageTitle.Wrapper>

      <Card.List>
        <BasicInfo contract={contract} />
        <Carrier contract={contract} />
        <Configuration contract={contract} />
      </Card.List>
    </PageWrapper>
  );
}
